import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Moon = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.BgColor ? "0 0 105 104" : "0 0 24 24"}
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={props.size}
            height={props.size}>
            {props.BgColor ? <rect x="0.5" width="104" height="104" rx="50" fill={props.BgColor} /> : null}
            <path d="M3.32031 11.6835C3.32031 16.6541 7.34975 20.6835 12.3203 20.6835C16.1075 20.6835 19.3483 18.3443 20.6768 15.032C19.6402 15.4486 18.5059 15.6834 17.3203 15.6834C12.3497 15.6834 8.32031 11.654 8.32031 6.68342C8.32031 5.50338 8.55165 4.36259 8.96453 3.32996C5.65605 4.66028 3.32031 7.89912 3.32031 11.6835Z" 
                stroke={props.color ? props.color : "#0076A8"} 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"/>
        </SvgStyled>
    );
};

export default Moon;
